<template>
  <nav :class="`navbar ${expandClass}`">
    <div class="container-fluid">
      <slot />

      <button
        type="button"
        :class="['navbar-toggler', !expanded && 'collapsed']"
        :aria-controls="id"
        :aria-expanded="expanded ? 'true' : 'false'"
        aria-label="Toggle navigation"
        @click="toggle"
      >
        <span class="navbar-toggler-icon" />
      </button>

      <div :id="id" :class="['collapse navbar-collapse', expanded && 'expanded']">
        <ul class="navbar-nav ms-auto mt-4 mt-lg-0">
          <component
            :is="getNavItemComponent(item)"
            v-for="(item, index) in items"
            :id="`nav-item-${index}`"
            :key="index"
            :class="['nav-item', item.border && 'nav-item-border']"
            :item="item"
            :index="index"
            v-bind="item.props"
          />
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { defineAsyncComponent, computed, ref } from 'vue'

function getNavItemComponent (item) {
  const componentName = item.type === 'component'
    ? item.label
    : item.submenu?.length
      ? 'GuNavItemDropdown'
      : 'GuNavItemLink'

  // Vite needs a prefix for dynamically imported components
  // @see https://github.com/rollup/plugins/tree/master/packages/dynamic-import-vars#limitations
  return defineAsyncComponent(() => import(`./GuNavItem${componentName.substring(9)}.vue`))
}

const props = defineProps({
  items: {
    type: Array,
    default () {
      return []
    },
  },
  expand: {
    type: String,
    default: 'lg',
  },
  id: {
    type: String,
    default: 'main-navigation',
  },
})

const expanded = ref(false)

const expandClass = computed(() => {
  return `navbar-expand-${props.expand}`
})

const toggle = () => {
  expanded.value = !expanded.value
}
</script>
